/** DTO type for ReccoTopicResponse */
export type ReccoTopicResponse = ReccoTopicDTO[];

/** Health topic categories used by the Recco recommendation engine */
export enum ReccoTopicDTO {
  PHYSICAL_ACTIVITY = 'physical_activity',
  NUTRITION = 'nutrition',
  MENTAL_WELLBEING = 'mental_wellbeing',
  RELAXATION = 'relaxation',
  SLEEP = 'sleep',
}
